<div class="rounded d-none d-md-block" id="view-options">
  <span class="mr-3">View: </span>
  <a href="#" (click)="setListDisplay('list')" title="Use list view (more detail)">
    <fa-icon [icon]="['fas','th-list']" class="fa-lg mx-2"
      [class.faded]="courseFilterService.courseListDisplayType != 'list'"></fa-icon>
  </a>
  <a href="#" (click)="setListDisplay('grid')" title="Use grid view (less detail)">
    <fa-icon [icon]="['fas','th']" class="fa-lg" [class.faded]="courseFilterService.courseListDisplayType != 'grid'">
    </fa-icon>
  </a>
</div>

<div class="d-block d-md-none" id="view-options">
  <a href="#" (click)="setListDisplay('list')">
    <fa-icon [icon]="['fas','th-list']" class="fa-sm mx-2"
      [class.faded]="courseFilterService.courseListDisplayType != 'list'"></fa-icon>
  </a>
  <a href="#" (click)="setListDisplay('grid')">
    <fa-icon [icon]="['fas','th']" class="fa-sm" [class.faded]="courseFilterService.courseListDisplayType != 'grid'">
    </fa-icon>
  </a>
</div>
